import React from 'react';
import ReactDOM from 'react-dom';
import Header from './Header';
import Footer from './Footer';
import PageHero from './PageHero';
import QuadChart from '../util/QuadChart';


const Layout=()=>
{
  return (
    <>

      <div className="header">
        <Header />
      </div>

      <div className="header-pannel"></div>

      <div className="container py-4">
        <PageHero />
        <QuadChart />
      </div>

      <Footer />

    </>
  )
}

export default Layout;
